var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ActionPendingModal',{attrs:{"header":"Importing earnings"}},[_vm._v("\n  Please do not leave this page or close your browser, while we import\n  earnings for your workers.\n")])}
var staticRenderFns = []

export { render, staticRenderFns }